import { Box, Container } from "@mui/material";
import React from "react";

export default function LoadingComp({ children }) {
  return (
    <Container
      sx={{
        display: "flex",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box className="loader">{children}</Box>
    </Container>
  );
}
